import {ReactElement} from 'react'
import {Trans} from 'react-i18next'

import {getFormattedAmount} from '../../../../../common/utils'
import messages from '../../../../../assets/messages'
import {Currency} from '../../../../../graphql/types'
import {RefundWithdrawSchemaItem} from '../types'
import {RefundInformation} from '../RefundInformation'
import {AmountToRefundItem} from './AmountToRefundItem'
import {useStyles} from './styles'

type RefundSectionProps = {
  accountId: number
  clientId: number
  totalAmountToRefund: number
  currency: Currency | null
  amountsToRefund: {amount: number; details: string; vendor: string}[]
  refundWithdrawSchema: RefundWithdrawSchemaItem[]
  withRefundInfo: boolean
  onlySelectPaymentMethodFlow: boolean
  onDepositMethodVerificationSubmittedModalOpen: () => void
}

function RefundSection(props: RefundSectionProps): ReactElement {
  const classes = useStyles()
  const {
    accountId,
    clientId,
    totalAmountToRefund,
    currency,
    amountsToRefund,
    refundWithdrawSchema,
    withRefundInfo,
    onlySelectPaymentMethodFlow,
    onDepositMethodVerificationSubmittedModalOpen,
  } = props

  return (
    <div className={classes.container}>
      <div className={classes.title}>
        <Trans
          {...messages.refundInAccordanceToAML}
          values={{amount: getFormattedAmount({currency, amount: totalAmountToRefund})}}
          components={[<span className={classes.amountToRefund}>amountToRefund</span>]}
        />
      </div>
      {amountsToRefund.map(({amount, details, vendor}, index) => (
        <div key={index} className={classes.listContainer}>
          <AmountToRefundItem
            amount={amount}
            details={details}
            currency={currency}
            vendor={vendor}
          />
        </div>
      ))}
      {withRefundInfo ? (
        <RefundInformation
          accountId={accountId}
          clientId={clientId}
          refundWithdrawSchema={refundWithdrawSchema}
          onlySelectPaymentMethodFlow={onlySelectPaymentMethodFlow}
          additionalItems={
            <li>
              <Trans
                {...messages.cardPaymentProcessingTime}
                components={[
                  <span className={classes.cardPaymentProcessingTime}>
                    cardPaymentProcessingTime
                  </span>,
                ]}
              />
            </li>
          }
          onDepositMethodVerificationSubmittedModalOpen={
            onDepositMethodVerificationSubmittedModalOpen
          }
        />
      ) : null}
    </div>
  )
}

export {RefundSection}
